/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Dhvanit Popat",
  title: "Hi all, I'm Dhvanit",
  subTitle: emoji(
    "Backend Software Engineer @ Google 🚀 with 7+ years building distributed systems, cloud infrastructure, and large-scale monitoring. I architect high-performance microservices and AI/RAG pipelines in Go, Python, and Node.js."
  ),
  resumeLink: "/Dhvanit_Popat_Resume.pdf", // Self-hosted from public/. Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Dhvanit41",
  linkedin: "https://in.linkedin.com/in/dhvanit-popat-a076a216b",
  gmail: "dhvanitpopat555@gmail.com",
  leetCode: "https://leetcode.com/Dhvanit/",
  upwork: "https://www.upwork.com/freelancers/~01e323e883fd3c560a/",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "BACKEND ENGINEER BUILDING RELIABLE, LARGE-SCALE DISTRIBUTED SYSTEMS IN THE CLOUD",
  skills: [
    emoji(
      "⚡ Architect high-performance microservices and backend platforms that serve enterprise scale"
    ),
    emoji(
      "⚡ Design proactive monitoring, SLO alerting, and automated incident-response for critical pipelines"
    ),
    emoji(
      "⚡ Build AI / RAG pipelines with LLMs and vector databases to surface knowledge at scale"
    ),
    emoji(
      "⚡ Ship cloud infrastructure and CI/CD on GCP & AWS with Docker and Kubernetes"
    ),
    emoji(
      "⚡ Competitive programmer with a demonstrated history of solving problems in DSA"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Go",
      fontAwesomeClassname: "fab fa-golang"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Node.js / NestJS",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "JavaScript / TypeScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Google Cloud (GCP)",
      fontAwesomeClassname: "fas fa-cloud"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-dharmachakra"
    },
    {
      skillName: "SQL · Spanner · BigQuery",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Kafka · Distributed Systems",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "AI / ML / RAG",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "Git & GitHub Actions",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "V.V.P. Engineering College",
      logo: require("./assets/images/education.caed892b.svg"),
      subHeader: "B.E. in Information Technology — Gujarat Technological University",
      duration: "September 2015 - April 2019",
      desc: "Graduated with a CGPA of 7.95.",
      descBullets: [
        "Key courses: Data Structures & Algorithms, DBMS, Distributed Algorithms, Approximation Algorithms, Operating Systems, Computer Networks."
      ]
    },
    {
      schoolName: "GSHSEB — Senior Secondary",
      logo: require("./assets/images/education.caed892b.svg"),
      subHeader: "Higher Secondary Certificate (Science)",
      duration: "2013 - 2015",
      desc: "Scored 70% in the Gujarat Secondary and Higher Secondary Education Board examinations."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend & Distributed Systems",
      progressPercentage: "92%"
    },
    {
      Stack: "Cloud & Infrastructure (GCP / AWS)",
      progressPercentage: "88%"
    },
    {
      Stack: "Monitoring, SLOs & DevOps",
      progressPercentage: "85%"
    },
    {
      Stack: "Data Structures and Algorithms",
      progressPercentage: "90%"
    },
  ],
  displayCodersrank: false
};


const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer (L4)",
      company: "Google",
      companylogo: require("./assets/images/googleLogo.svg"),
      date: "Sept 2024 – Present",
      desc: "Building the backend and monitoring backbone for enterprise threat-detection pipelines that protect global security systems.",
      descBullets: [
        "Engineered a configuration-management tool with automated validation that prevents bad configs from reaching global security pipelines.",
        "Designed proactive monitoring and automated SLO alerting, significantly accelerating incident response.",
        "Architected a multi-tier automated incident-response framework that detects config drift and cut pipeline latency by 15%.",
        "Consolidated disparate intake services into a unified onboarding pipeline, reducing integration friction for new clients by 30%.",
        "Built a Retrieval-Augmented Generation (RAG) prototype for SecOps, reaching 85%+ accuracy querying security playbooks."
      ]
    },
    {
      role: "Senior Software Engineer (Backend)",
      company: "Unique Schools",
      companylogo: require("./assets/images/uniqueSchoolsLogo.jpg"),
      date: "Jan 2023 – Aug 2024",
      desc: "Led backend architecture for a scalable ed-tech platform serving schools across India.",
      descBullets: [
        "Led development of scalable microservices in Node.js and NestJS, optimizing execution to significantly reduce system latency.",
        "Architected cloud infrastructure on AWS and Docker with efficient deployment pipelines that cut operational cost and testing cycles.",
        "Enhanced CI/CD via GitHub Actions to accelerate release cycles and boost developer productivity."
      ]
    },
    {
      role: "Backend Engineer",
      company: "GEVME (Singapore)",
      companylogo: require("./assets/images/Gevmelogo.png"),
      date: "Oct 2021 – Oct 2022",
      desc: "GEVME is a flagship SaaS platform used by event professionals to build, operate, and monetize large-scale virtual experiences.",
      descBullets: [
        "Engineered robust backend systems powering the company's flagship virtual-event platform.",
        "Built a real-time analytics dashboard with insights on attendee behavior, livestream stats, and sponsor conversion metrics.",
        "Architected custom web components and micro-apps (agendas, notifications, live streaming), drastically reducing deployment times."
      ]
    },
    {
      role: "Software Engineer (Backend)",
      company: "Accenture",
      companylogo: require("./assets/images/AccentuerLogo.png"),
      date: "Nov 2019 – Sept 2021",
      desc: "Accenture is a multinational professional-services company specialising in IT services and consulting.",
      descBullets: [
        "Designed and built an automated ETL tool for OLAP data-warehousing, streamlining massive data-processing pipelines.",
        "Contributed to the AI engineering team delivering actionable last-mile analytics for a large-scale consumer business in India.",
        "Accelerated dashboard delivery by building four reusable analytical widgets backed by robust microservices."
      ]
    }
  ]
};

/* Your Opn Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false  // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  achievementsCards: [
    {
      title: "Problem Solving (Intermediate)",
      image: require("./assets/images/HackerRank_logo.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/d55ff65b59d9"
        }
      ]
    },
    {
      title: "Node JS: Advanced Concepts",
      image: require("./assets/images/Udemy-Logo.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-87db94bb-36c0-4013-aa12-03a9214f5ed3/"
        }
      ]
    },
    {
      title: "Algoexpert- Data structure and Algorithms",
      image: require("./assets/images/ae-social-logo.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://certificate.algoexpert.io/AlgoExpert%20Certificate%20AE-d0e7eaf38d"
        }
      ]
    },

    {
      title: "JavaScript (Basic)",
      image: require("./assets/images/HackerRank_logo.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/131809f3e657"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@Dhvanit41/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/Dhvanit41-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "dhvanitpopat555@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
